import React from 'react';
import { View, ActivityIndicator } from 'react-native';
import { useAppTheme } from '@/providers/theme-provider';
import { useLocalSearchParams } from 'expo-router';
import { PageTitle } from '@/components/seo/page-title';
import { QuickCheckInPage } from '@/features/check-in/components';
import { useDraftLoader } from '@/features/check-in/hooks/use-draft-loader';

export default function QuickCheckInScreen() {
  const theme = useAppTheme();
  const params = useLocalSearchParams<{
    draftId?: string;
    businessId?: string;
    menuItemId?: string;
  }>();

  const { isLoading, draft: initialDraft } = useDraftLoader(params.draftId);

  if (isLoading) {
    return (
      <View className="flex-1 bg-background justify-center items-center">
        <ActivityIndicator size="large" color={theme.colors.primary} />
      </View>
    );
  }

  return (
    <>
      <PageTitle title="Check In" />
      <QuickCheckInPage
        initialDraft={initialDraft}
        initialBusinessId={params.businessId}
        initialMenuItemId={params.menuItemId}
      />
    </>
  );
}
